"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ComposerProvider", {
    enumerable: true,
    get: function() {
        return ComposerProvider;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
var _ = require("../index");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ComposerProvider = function(param) {
    var children = param.children, _param_theme = param.theme, theme = _param_theme === void 0 ? {} : _param_theme, _param_resetCSS = param.resetCSS, resetCSS = _param_resetCSS === void 0 ? true : _param_resetCSS;
    var extended = (0, _react1.extendTheme)(_.theme, theme);
    return _react.default.createElement(_react1.ChakraProvider, {
        theme: extended,
        resetCSS: resetCSS
    }, children);
};
